module.exports = __webpack_public_path__ + "img/CaseFunctionality.dab45e02.png";